import styled from 'styled-components'

export const Defs = styled.defs``
